"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/******/(function () {
  // webpackBootstrap
  /******/
  var __webpack_modules__ = {
    /***/722: /***/function _() {
      var VariantSelection = /*#__PURE__*/function (_HTMLElement) {
        _inherits(VariantSelection, _HTMLElement);
        var _super = _createSuper(VariantSelection);
        function VariantSelection() {
          var _this;
          _classCallCheck(this, VariantSelection);
          _this = _super.call(this);
          _this._loaded = false;
          _this._productFetcher = Promise.resolve(false);
          _this._onMainElChange = function (event) {
            _this.variant = event.currentTarget.value;
          };
          var mainInputEl = _this.querySelector('input[data-variants]');
          _this._mainEl = mainInputEl || _this.querySelector('select[data-variants]');
          return _this;
        }
        _createClass(VariantSelection, [{
          key: "variant",
          get: function get() {
            return this.getAttribute('variant');
          },
          set: function set(value) {
            if (value) {
              this.setAttribute('variant', value);
            } else {
              this.removeAttribute('variant');
            }
          }
        }, {
          key: "connectedCallback",
          value: function connectedCallback() {
            this._productFetcher = this._fetchProduct();
            var mainInputEl = this.querySelector('input[data-variants]');
            this._mainEl = mainInputEl || this.querySelector('select[data-variants]');
            this._mainEl.addEventListener('change', this._onMainElChange);
            this.variant = this._mainEl.value;
          }
        }, {
          key: "disconnectedCallback",
          value: function disconnectedCallback() {
            this._mainEl.removeEventListener('change', this._onMainElChange);
            this._mainEl = null;
          }
        }, {
          key: "attributeChangedCallback",
          value: function attributeChangedCallback(name, oldValue, newValue) {
            if (oldValue === newValue) return;
            switch (name) {
              case 'variant':
                this._changeVariant(newValue);
                break;
            }
          }
        }, {
          key: "getProduct",
          value: function getProduct() {
            return this._loaded ? Promise.resolve(this._product) : this._productFetcher;
          }
        }, {
          key: "getVariant",
          value: function getVariant() {
            var _this2 = this;
            return this.getProduct().then(function (product) {
              return product ? product.variants.find(function (v) {
                return v.id.toString() === _this2.variant;
              }) || false : false;
            })["catch"](function () {
              return false;
            });
          }
        }, {
          key: "getState",
          value: function getState() {
            var _this3 = this;
            return this.getVariant().then(function (variant) {
              return variant ? 'selected' : _this3.getAttribute('variant');
            });
          }
        }, {
          key: "_changeVariant",
          value: function _changeVariant(value) {
            var _this4 = this;
            this._dispatchEvent(value).then(function () {
              _this4._mainEl.value = value;
            });
          }
        }, {
          key: "_fetchProduct",
          value: function _fetchProduct() {
            var _this5 = this;
            return fetch(this.getAttribute('product-url')).then(function (response) {
              return response.json();
            }).then(function (product) {
              _this5._product = product;
              return product;
            })["catch"](function () {
              _this5._product = null;
            })["finally"](function () {
              _this5._loaded = true;
            });
          }
        }, {
          key: "_dispatchEvent",
          value: function _dispatchEvent(value) {
            var _this6 = this;
            return this.getProduct().then(function (product) {
              var variant = product ? product.variants.find(function (v) {
                return v.id.toString() === value;
              }) || false : false;
              var state = variant ? 'selected' : value;
              var event = new CustomEvent('variant-change', {
                detail: {
                  product: product,
                  variant: variant,
                  state: state
                }
              });
              _this6.dispatchEvent(event);
            });
          }
        }], [{
          key: "observedAttributes",
          get: function get() {
            return ['variant'];
          }
        }]);
        return VariantSelection;
      }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
      var valueElementType = {
        select: 'option',
        radio: 'input[type="radio"]'
      };
      function _setSelectedOptions(selectOptions, radioOptions, selectedOptions) {
        selectOptions.forEach(function (_ref) {
          var option = _ref.option;
          option.value = selectedOptions[parseInt(option.dataset.variantOptionIndex, 10)];
        });
        radioOptions.forEach(function (_ref2) {
          var values = _ref2.values;
          values.forEach(function (value) {
            value.checked = value.value === selectedOptions[parseInt(value.dataset.variantOptionValueIndex, 10)];
          });
        });
      }
      function getOptions(optionsEls) {
        var select = [];
        var radio = [];
        for (var i = 0; i < optionsEls.length; i++) {
          var optionEl = optionsEls[i];
          var wrappers = optionEl.matches('[data-variant-option-value-wrapper]') ? [optionEl] : Array.prototype.slice.call(optionEl.querySelectorAll('[data-variant-option-value-wrapper]'));
          var values = optionEl.matches('[data-variant-option-value]') ? [optionEl] : Array.prototype.slice.call(optionEl.querySelectorAll('[data-variant-option-value]'));
          if (!values.length) break;
          var option = {
            option: optionEl,
            wrappers: wrappers,
            values: values
          };
          if (values[0].matches(valueElementType.select)) {
            select.push(option);
          } else if (values[0].matches(valueElementType.radio)) {
            radio.push(option);
          }
        }
        return {
          select: select,
          radio: radio
        };
      }
      function _getSelectedOptions(product, selectOptions, radioOptions) {
        var options = product.options.map(function () {
          return 'not-selected';
        });
        selectOptions.forEach(function (_ref3) {
          var option = _ref3.option;
          if (option.value !== 'not-selected') {
            options[parseInt(option.dataset.variantOptionIndex, 10)] = option.value;
          }
        });
        radioOptions.forEach(function (_ref4) {
          var values = _ref4.values;
          values.forEach(function (value) {
            if (value.checked) {
              options[parseInt(value.dataset.variantOptionValueIndex, 10)] = value.value;
            }
          });
        });
        return options;
      }
      function getVariantFromSelectedOptions(variants, selectedOptions) {
        for (var i = 0; i < variants.length; i++) {
          var variant = variants[i];
          var isVariant = variant.options.every(function (option, index) {
            return option === selectedOptions[index];
          });
          if (isVariant) return variant; // We found the variant
        }

        return false;
      }
      function _getVariant(variants, options) {
        return variants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === options[index];
          });
        });
      }
      function _setOptionsMap(product, selectedOptions, optionsMap, option1) {
        var option2 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var option3 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
        var updatedOptionsMap = _objectSpread({}, optionsMap);
        var options = [option1, option2, option3].filter(function (option) {
          return !!option;
        });
        var variant = _getVariant(product.variants, options);
        var variantOptionMatches = options.filter(function (option, index) {
          return option === selectedOptions[index];
        }).length;
        var isCurrentVariant = variantOptionMatches === product.options.length;
        var isNeighbor = variantOptionMatches === product.options.length - 1;
        for (var i = 0; i < options.length; i++) {
          var option = options[i];
          if (option) {
            var _optionsMap$i$option = optionsMap[i][option],
              setByCurrentVariant = _optionsMap$i$option.setByCurrentVariant,
              setByNeighbor = _optionsMap$i$option.setByNeighbor,
              accessible = _optionsMap$i$option.accessible,
              available = _optionsMap$i$option.available;
            if (variant) {
              accessible = variant.available || accessible; // The current variant is always
              // the priority for option availability

              if (isCurrentVariant) {
                setByCurrentVariant = true;
                available = variant.available;
              } else if (!setByCurrentVariant && isNeighbor) {
                // If the variant is a neighbor
                // And the option doesn't belong to the variant
                // Use its availability information for the option
                // If multiple neighbors exist, prefer true
                available = setByNeighbor ? available || variant.available : variant.available;
                setByNeighbor = true;
              }
            } else if (isCurrentVariant) {
              // Catch case where current variant doesn't exist
              // Ensure availability is false
              setByCurrentVariant = true;
              available = false;
            } else if (!setByCurrentVariant && isNeighbor) {
              // Catch case where neighbor doesn't exist
              // Ensure availability is false
              // If multiple neighbors exist, prefer true
              available = setByNeighbor ? available : false;
              setByNeighbor = true;
            } // If the option isn't set by either
            // the current variant or a neighbor
            // default to general accessibility

            if (!setByCurrentVariant && !setByNeighbor) {
              available = accessible;
            }
            updatedOptionsMap[i][option] = {
              setByCurrentVariant: setByCurrentVariant,
              setByNeighbor: setByNeighbor,
              accessible: accessible,
              available: available
            };
          }
        }
        return updatedOptionsMap;
      }
      function getOptionsAccessibility(product, selectedOptions) {
        var optionsMap = product.options.map(function () {
          return {};
        });
        for (var i = 0; i < product.options.length; i++) {
          for (var j = 0; j < product.variants.length; j++) {
            var variant = product.variants[j];
            var option = variant.options[i];
            optionsMap[i][option] = {
              setByCurrentVariant: false,
              setByNeighbor: false,
              accessible: false,
              available: false
            };
          }
        }
        var option1Values = optionsMap.length >= 1 ? Object.keys(optionsMap[0]) : [];
        var option2Values = optionsMap.length >= 2 ? Object.keys(optionsMap[1]) : [];
        var option3Values = optionsMap.length >= 3 ? Object.keys(optionsMap[2]) : [];
        option1Values.forEach(function (option1Value) {
          option2Values.forEach(function (option2Value) {
            option3Values.forEach(function (option3Value) {
              optionsMap = _setOptionsMap(product, selectedOptions, optionsMap, option1Value, option2Value, option3Value);
            });
            if (!option3Values.length) {
              optionsMap = _setOptionsMap(product, selectedOptions, optionsMap, option1Value, option2Value);
            }
          });
          if (!option2Values.length) {
            optionsMap = _setOptionsMap(product, selectedOptions, optionsMap, option1Value);
          }
        });
        return optionsMap;
      }
      function updateOptions(product, selectOptions, radioOptions, selectedOptions, disableUnavailableOptions, removeUnavailableOptions) {
        var options = [].concat(_toConsumableArray(selectOptions), _toConsumableArray(radioOptions));
        if (options.length === 0) {
          return;
        }
        var optionsAccessibility = getOptionsAccessibility(product, selectedOptions); // Iterate over each option type
        var _loop = function _loop(i) {
          // Corresponding select dropdown, if it exists
          var optionValues = options.find(function (_ref5) {
            var option = _ref5.option;
            if (parseInt(option.dataset.variantOptionIndex, 10) === i) {
              return true;
            }
            return false;
          });
          if (optionValues) {
            var fragment = document.createDocumentFragment();
            var option = optionValues.option,
              wrappers = optionValues.wrappers,
              values = optionValues.values;
            for (var j = values.length - 1; j >= 0; j--) {
              var wrapper = wrappers[j];
              var optionValue = values[j];
              var value = optionValue.value;
              var _ref6 = value in optionsAccessibility[i] ? optionsAccessibility[i][value] : false,
                available = _ref6.available;
              var _ref7 = value in optionsAccessibility[i] ? optionsAccessibility[i][value] : false,
                accessible = _ref7.accessible;
              var isChooseOption = value === 'not-selected'; // Option element to indicate unchosen option
              // Disable unavailable options

              optionValue.disabled = isChooseOption || disableUnavailableOptions && !accessible;
              optionValue.dataset.variantOptionAccessible = accessible;
              optionValue.dataset.variantOptionAvailable = available;
              if (!removeUnavailableOptions || accessible || isChooseOption) {
                fragment.insertBefore(wrapper, fragment.firstElementChild);
              }
            }
            option.innerHTML = '';
            option.appendChild(fragment);
            var chosenValue = values.find(function (value) {
              return value.selected || value.checked;
            });
            option.dataset.variantOptionChosenValue = chosenValue && chosenValue.value !== 'not-selected' ? chosenValue.value : false;
          }
        };
        for (var i = 0; i < product.options.length; i++) {
          _loop(i);
        }
      }
      var OptionsSelection = /*#__PURE__*/function (_HTMLElement2) {
        _inherits(OptionsSelection, _HTMLElement2);
        var _super2 = _createSuper(OptionsSelection);
        function OptionsSelection() {
          var _this7;
          _classCallCheck(this, OptionsSelection);
          _this7 = _super2.call(this);
          _this7.style.display = '';
          _this7._events = [];
          _this7._onChangeFn = _this7._onOptionChange.bind(_assertThisInitialized(_this7));
          _this7._optionsEls = _this7.querySelectorAll('[data-variant-option]');
          var _getOptions = getOptions(_this7._optionsEls);
          _this7._selectOptions = _getOptions.select;
          _this7._radioOptions = _getOptions.radio;
          _this7._associateVariantSelection(_this7.getAttribute('variant-selection'));
          return _this7;
        }
        _createClass(OptionsSelection, [{
          key: "variantSelection",
          get: function get() {
            return this.getAttribute('variant-selection');
          },
          set: function set(value) {
            if (value) {
              this.setAttribute('variant-selection', value);
            } else {
              this.removeAttribute('variant-selection');
            }
          }
        }, {
          key: "connectedCallback",
          value: function connectedCallback() {
            var _this8 = this;
            this._optionsEls = this.querySelectorAll('[data-variant-option]');
            var _getOptions2 = getOptions(this._optionsEls);
            this._selectOptions = _getOptions2.select;
            this._radioOptions = _getOptions2.radio;
            this._associateVariantSelection(this.getAttribute('variant-selection'));
            this._selectOptions.forEach(function (_ref8) {
              var option = _ref8.option;
              option.addEventListener('change', _this8._onChangeFn);
              _this8._events.push({
                el: option,
                fn: _this8._onChangeFn
              });
            });
            this._radioOptions.forEach(function (_ref9) {
              var values = _ref9.values;
              values.forEach(function (value) {
                value.addEventListener('change', _this8._onChangeFn);
                _this8._events.push({
                  el: value,
                  fn: _this8._onChangeFn
                });
              });
            });
            this._onOptionChange();
          }
        }, {
          key: "disconnectedCallback",
          value: function disconnectedCallback() {
            this._resetOptions();
            this._events.forEach(function (_ref10) {
              var el = _ref10.el,
                fn = _ref10.fn;
              return el.removeEventListener('change', fn);
            });
            this._events = [];
          }
        }, {
          key: "attributeChangedCallback",
          value: function attributeChangedCallback(name, _oldValue, newValue) {
            switch (name) {
              case 'variant-selection':
                this._associateVariantSelection(newValue);
                break;
              case 'disable-unavailable':
              case 'remove-unavailable':
                this._updateOptions(this.hasAttribute('disable-unavailable'), this.hasAttribute('remove-unavailable'));
                break;
            }
          }
        }, {
          key: "getSelectedOptions",
          value: function getSelectedOptions() {
            var _this9 = this;
            if (!this._variantSelection) return Promise.resolve(null);
            return this._variantSelection.getProduct().then(function (product) {
              if (!product) return null;
              return _getSelectedOptions(product, _this9._selectOptions, _this9._radioOptions);
            });
          }
        }, {
          key: "getVariantSelection",
          value: function getVariantSelection() {
            return this._variantSelection;
          }
        }, {
          key: "setSelectedOptions",
          value: function setSelectedOptions(selectedOptions) {
            _setSelectedOptions(this._selectOptions, this._radioOptions, selectedOptions);
            return this._updateOptions(this.hasAttribute('disable-unavailable'), this.hasAttribute('remove-unavailable'), selectedOptions);
          }
        }, {
          key: "_associateVariantSelection",
          value: function _associateVariantSelection(id) {
            this._variantSelection = id ? document.getElementById(id) : this.closest('variant-selection');
          }
        }, {
          key: "_updateLabels",
          value: function _updateLabels() {
            // Update any labels
            for (var i = 0; i < this._optionsEls.length; i++) {
              var optionsEl = this._optionsEls[i];
              var optionsNameEl = null;
              var parentElement = optionsEl.parentElement;
              while (parentElement && !optionsNameEl) {
                var tmpOptionsNameEl = parentElement.querySelector('[data-variant-option-name]');
                if (tmpOptionsNameEl) {
                  optionsNameEl = tmpOptionsNameEl;
                }
                var _parentElement = parentElement;
                parentElement = _parentElement.parentElement;
              }
              if (optionsNameEl) {
                optionsNameEl.dataset.variantOptionChosenValue = optionsEl.dataset.variantOptionChosenValue;
                if (optionsEl.dataset.variantOptionChosenValue !== 'false') {
                  optionsNameEl.innerHTML = optionsNameEl.dataset.variantOptionName;
                  var optionNameValueSpan = optionsNameEl.querySelector('span');
                  if (optionNameValueSpan) {
                    optionNameValueSpan.innerHTML = optionsEl.dataset.variantOptionChosenValue;
                  }
                } else {
                  optionsNameEl.innerHTML = optionsNameEl.dataset.variantOptionChooseName;
                }
              }
            }
          }
        }, {
          key: "_resetOptions",
          value: function _resetOptions() {
            return this._updateOptions(false, false);
          }
        }, {
          key: "_updateOptions",
          value: function _updateOptions(disableUnavailableOptions, removeUnavailableOptions) {
            var _this10 = this;
            var selectedOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            if (!this._variantSelection) return Promise.resolve(false);
            return this._variantSelection.getProduct().then(function (product) {
              updateOptions(product, _this10._selectOptions, _this10._radioOptions, selectedOptions || _getSelectedOptions(product, _this10._selectOptions, _this10._radioOptions), disableUnavailableOptions, removeUnavailableOptions);
              _this10._updateLabels();
            }).then(function () {
              return true;
            });
          }
        }, {
          key: "_updateVariantSelection",
          value: function _updateVariantSelection(product, selectedOptions) {
            if (!this._variantSelection) return;
            var variant = getVariantFromSelectedOptions(product.variants, selectedOptions);
            var isNotSelected = selectedOptions.some(function (option) {
              return option === 'not-selected';
            }); // Update master select

            if (variant) {
              this._variantSelection.variant = variant.id;
            } else {
              this._variantSelection.variant = isNotSelected ? 'not-selected' : 'unavailable';
            }
          }
        }, {
          key: "_onOptionChange",
          value: function _onOptionChange() {
            var _this11 = this;
            if (!this._variantSelection) return;
            this._variantSelection.getProduct().then(function (product) {
              if (!product) return;
              var selectedOptions = _getSelectedOptions(product, _this11._selectOptions, _this11._radioOptions);
              _this11._updateOptions(_this11.hasAttribute('disable-unavailable'), _this11.hasAttribute('remove-unavailable'), selectedOptions);
              _this11._updateVariantSelection(product, selectedOptions);
              OptionsSelection.synchronize(_this11);
            });
          }
        }], [{
          key: "observedAttributes",
          get: function get() {
            return ['variant-selection', 'disable-unavailable', 'remove-unavailable'];
          }
        }, {
          key: "synchronize",
          value: function synchronize(mainOptionsSelection) {
            var mainVariantSelection = mainOptionsSelection.getVariantSelection(); // Fast return if we aren't associated with a variant selection

            if (!mainVariantSelection) return Promise.resolve(false);
            return mainOptionsSelection.getSelectedOptions().then(function (selectedOptions) {
              // Update all other options selects associated with the same variant ui
              var optionsSelections = document.querySelectorAll('options-selection');
              optionsSelections.forEach(function (optionsSelection) {
                if (optionsSelection !== mainOptionsSelection && optionsSelection.getVariantSelection() === mainVariantSelection) {
                  optionsSelection.setSelectedOptions(selectedOptions);
                }
              });
            }).then(function () {
              return true;
            });
          }
        }]);
        return OptionsSelection;
      }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
      if (!customElements.get('variant-selection')) {
        customElements.define('variant-selection', VariantSelection);
      }
      if (!customElements.get('options-selection')) {
        customElements.define('options-selection', OptionsSelection);
      }
      /***/
    }

    /******/
  };
  /************************************************************************/
  /******/ // The module cache
  /******/
  var __webpack_module_cache__ = {};
  /******/
  /******/ // The require function
  /******/
  function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/var cachedModule = __webpack_module_cache__[moduleId];
    /******/
    if (cachedModule !== undefined) {
      /******/return cachedModule.exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/
    var module = __webpack_module_cache__[moduleId] = {
      /******/ // no module.id needed
      /******/ // no module.loaded needed
      /******/exports: {}
      /******/
    };
    /******/
    /******/ // Execute the module function
    /******/
    __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
    /******/
    /******/ // Return the exports of the module
    /******/
    return module.exports;
    /******/
  }
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/compat get default export */
  /******/
  (function () {
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
      /******/var getter = module && module.__esModule ? /******/function () {
        return module['default'];
      } : /******/function () {
        return module;
      };
      /******/
      __webpack_require__.d(getter, {
        a: getter
      });
      /******/
      return getter;
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/define property getters */
  /******/
  (function () {
    /******/ // define getter functions for harmony exports
    /******/__webpack_require__.d = function (exports, definition) {
      /******/for (var key in definition) {
        /******/if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
          /******/Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
          /******/
        }
        /******/
      }
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/hasOwnProperty shorthand */
  /******/
  (function () {
    /******/__webpack_require__.o = function (obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    };
    /******/
  })();
  /******/
  /************************************************************************/
  var __webpack_exports__ = {};
  // This entry need to be wrapped in an IIFE because it need to be in strict mode.
  (function () {
    "use strict";

    /* harmony import */
    var _pixelunion_shopify_variants_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(722);
    /* harmony import */
    var _pixelunion_shopify_variants_ui__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_pixelunion_shopify_variants_ui__WEBPACK_IMPORTED_MODULE_0__);

    // Section Shopify Shopify.theme editor events

    $(document).on('shopify:section:reorder', function (e) {
      var $target = $(e.target);
      var $parentSection = $('#shopify-section-' + e.detail.sectionId);
      if (Shopify.theme.jsHeader.enable_overlay == true) {
        Shopify.theme.jsHeader.unload();
        Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
      }
    });
    $(document).on('shopify:section:load', function (e) {
      // Shopify section as jQuery object
      var $section = $(e.target);

      // Vanilla js selection of Shopify section
      var section = document.getElementById('shopify-section-' + e.detail.sectionId);

      // Blocks within section
      var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');
      var sectionObjectUrl = $section.find('[data-theme-editor-load-script]').attr('src');

      // Check classes on schema and look for js (eg. jsMap)
      for (var i = 0; i < section.classList.length; i++) {
        if (section.classList[i].substring(0, 2) === "js") {
          var triggerClass = section.classList[i];

          // Check to see if section script exists
          if (typeof Shopify.theme[triggerClass] == 'undefined') {
            // make AJAX call to load script
            Shopify.theme.loadScript(triggerClass, sectionObjectUrl, function () {
              Shopify.theme[triggerClass].init($(section));
            });
          } else {
            if (Shopify.theme[triggerClass]) {
              // console.log('Section: ' + triggerClass + ' has been loaded.')
              Shopify.theme[triggerClass].init($(section));
            } else {
              // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
            }
          }
        }
      }

      // Load video feature
      Shopify.theme.video.init();

      // Scrolling animations
      Shopify.theme.animation.init();

      // Initialize reviews
      Shopify.theme.productReviews.init();

      // Infinite scrolling
      Shopify.theme.infiniteScroll.init();

      // Disclosure menus
      Shopify.theme.disclosure.enable();

      // Search
      $(document).on('click', '[data-show-search-trigger]', function () {
        Shopify.theme.jsHeader.showSearch();
      });
      $('.search-overlay__close').on('click', function () {
        Shopify.theme.jsHeader.hideSearch();
      });
      if (Shopify.theme_settings.enable_autocomplete == true) {
        Shopify.theme.predictiveSearch.init();
      }
      // Product review scroll
      Shopify.theme.productReviews.productReviewScroll();
    });
    $(document).on('shopify:section:unload', function (e) {
      // Shopify section as jQuery object
      var $section = $(e.target);

      // Vanilla js selection of Shopify section
      var section = document.getElementById('shopify-section-' + e.detail.sectionId);

      // Blocks within section
      var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

      // Check classes on schema and look for js (eg. jsMap)
      for (var i = 0; i < section.classList.length; i++) {
        if (section.classList[i].substring(0, 2) === "js") {
          var triggerClass = section.classList[i];
          if (Shopify.theme[triggerClass]) {
            // console.log('Section: ' + triggerClass + ' is unloaded.')
            Shopify.theme[triggerClass].unload($(section));
          } else {
            // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.unload() function exists.');
          }
        }
      }

      // Scrolling animations
      Shopify.theme.animation.unload($section);

      // QuantityBox
      Shopify.theme.quantityBox.unload($section);

      // Infinite scrolling
      Shopify.theme.infiniteScroll.unload($section);

      // Disclosure menus
      Shopify.theme.disclosure.enable();
    });
    $(document).on('shopify:section:select', function (e) {
      // Shopify section as jQuery object
      var $section = $(e.target);

      // Vanilla js selection of Shopify section
      var section = document.getElementById('shopify-section-' + e.detail.sectionId);

      // Force show state when section is selected in theme editor
      for (var i = 0; i < section.classList.length; i++) {
        if (section.classList[i].substring(0, 2) === "js") {
          var triggerClass = section.classList[i];
          if (Shopify.theme[triggerClass].showThemeEditorState) {
            Shopify.theme[triggerClass].showThemeEditorState(e.detail.sectionId, $section);
          }
        }
      }

      // Predictive search
      if (Shopify.theme_settings.enable_autocomplete == true) {
        Shopify.theme.predictiveSearch.init();
      }
      if (isScreenSizeLarge() && Shopify.theme.jsHeader.enable_overlay === true) {
        Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
      }
      if ($('.block__recommended-products').length > 0) {
        var $productPage = $('.block__recommended-products').parents('.product-page');
        Shopify.theme.jsRecommendedProducts.init($productPage);
      }
    });
    $(document).on('shopify:section:deselect', function (e) {
      // Shopify section as jQuery object
      var $section = $(e.target);

      // Vanilla js selection of Shopify section
      var section = document.getElementById('shopify-section-' + e.detail.sectionId);

      // Force hide state when section is selected in theme editor
      for (var i = 0; i < section.classList.length; i++) {
        if (section.classList[i].substring(0, 2) === "js") {
          var triggerClass = section.classList[i];
          if (Shopify.theme[triggerClass].showThemeEditorState) {
            Shopify.theme[triggerClass].hideThemeEditorState(e.detail.sectionId, $(section));
          }
        }
      }
    });

    // Block Shopify Shopify.theme editor events

    $(document).on('shopify:block:select', function (e) {
      var blockId = e.detail.blockId;
      var $parentSection = $('#shopify-section-' + e.detail.sectionId);
      var $block = $('#shopify-section-' + blockId);
      if ($('.jsFeaturedPromos').length > 0) {
        Shopify.theme.jsFeaturedPromos.blockSelect($parentSection, blockId);
      }
      if ($('.jsSlideshowWithText').length > 0) {
        Shopify.theme.jsSlideshowWithText.blockSelect($parentSection, blockId);
      }
      if ($('.jsSlideshowClassic').length > 0) {
        Shopify.theme.jsSlideshowClassic.blockSelect($parentSection, blockId);
      }
      if ($('.jsTestimonials').length > 0) {
        Shopify.theme.jsTestimonials.blockSelect($parentSection, blockId);
      }

      // Sidebar collection multi-tag filter
      if ($block.hasClass('sidebar__block')) {
        var $toggleBtn = $block.find('[data-sidebar-block__toggle="closed"]');
        if ($toggleBtn) {
          Shopify.theme.jsSidebar.openSidebarBlock($toggleBtn);
        }
      }

      // Predictive search
      if (Shopify.theme_settings.enable_autocomplete == true) {
        Shopify.theme.predictiveSearch.init();
      }

      // Scrolling animations
      Shopify.theme.animation.init();
    });
    $(document).on('shopify:block:deselect', function (e) {
      var $block = $('#shopify-section-' + e.detail.blockId);
      if ($block.hasClass('sidebar__block')) {
        var $toggleBtn = $block.find('[data-sidebar-block__toggle="open"]');
        if ($toggleBtn) {
          Shopify.theme.jsSidebar.closeSidebarBlock($toggleBtn);
        }
      }
    });
    $(document).on('shopify:block:load', function (e) {});

    // Document ready
    $(function () {
      var $jsSections = $('.shopify-section[class*=js]');

      // Loop through sections with js classes and load them in
      var $jsSectionNames = $jsSections.each(function () {
        for (var i = 0; i < this.classList.length; i++) {
          if (this.classList[i].substring(0, 2) === "js") {
            var triggerClass = this.classList[i];
            if (Shopify.theme[triggerClass]) {
              // console.log('Section: ' + triggerClass + ' has been loaded.')
              Shopify.theme[triggerClass].init($(this));
            } else {
              // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
            }
          }
        }
      });
      var resizeTimer;

      // Store window width in variable
      var width = $(window).width(),
        height = $(window).height();
      $(window).on('resize', function (e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (Shopify.theme.jsHeader.header_layout === 'vertical') {
            Shopify.theme.predictiveSearch.alignVerticalSearch();
          }
          if (!isScreenSizeLarge()) {
            // When 798 or less
            Shopify.theme.mobileMenu.init();
          } else {
            // When larger than 798
            Shopify.theme.mobileMenu.unload();
          }
        }, 250);
      });

      //Enable plyr
      Shopify.theme.video.init();

      // Predictive search
      if (Shopify.theme_settings.enable_autocomplete == true) {
        Shopify.theme.predictiveSearch.init();
      }
      if ($('a[href]').length) {
        Shopify.theme.handleNewTabLinks($('a[href]'));
      }
      Shopify.theme.dropdownMenu();
      Shopify.theme.disclosure.enable();

      // Scrolling animations
      Shopify.theme.animation.init();

      // QuantityBox
      Shopify.theme.quantityBox.init();

      /* Show associated variant image on hover */
      if (Shopify.theme_settings.show_collection_swatches == true) {
        Shopify.theme.thumbnail.enableSwatches();
      }

      /* Show secondary image on hover */
      if (Shopify.theme_settings.show_secondary_image == true) {
        Shopify.theme.thumbnail.showVariantImage();
      }

      // Quick shop
      if (Shopify.theme_settings.enable_quickshop) {
        Shopify.theme.thumbnail.showQuickShop();
      }

      // Currency converter
      if (Shopify.theme.currencyConverter) {
        Shopify.theme.currencyConverter.init();
      }

      //Infinite scrolling
      if ($('[data-custom-pagination]').length) {
        Shopify.theme.infiniteScroll.init();
      }
      $('.shopify-currency-form ul li').on('click', function () {
        $(this).parents('form').submit();
      });

      // Additional checkout buttons
      if (!isScreenSizeLarge()) {
        $('.additional-checkout-buttons').addClass('additional-checkout-buttons--vertical');
      }

      // Responsive Video
      Shopify.theme.responsiveVideo.init();

      // Flickity IOS Fix
      Shopify.theme.flickityIosFix();

      // Product review scroll
      Shopify.theme.productReviews.productReviewScroll();
    });

    /*============================================================================
    Slideshow arrows
    ==============================================================================*/

    if (Shopify.theme_settings.icon_style == 'icon_solid') {
      window.arrowShape = 'M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z';
    } else {
      window.arrowShape = 'M95,48H9.83L41,16.86A2,2,0,0,0,38.14,14L3.59,48.58a1.79,1.79,0,0,0-.25.31,1.19,1.19,0,0,0-.09.15l-.1.2-.06.2a.84.84,0,0,0,0,.17,2,2,0,0,0,0,.78.84.84,0,0,0,0,.17l.06.2.1.2a1.19,1.19,0,0,0,.09.15,1.79,1.79,0,0,0,.25.31L38.14,86A2,2,0,0,0,41,86a2,2,0,0,0,0-2.83L9.83,52H95a2,2,0,0,0,0-4Z';
    }
  })();

  /******/
})();